import { Resource_Type_Identifier } from "./teamManagement";
import { displayFps, videoTime, bpmList } from "./videoAndAudio";
import { humanResourceDirectoryList } from "./human"

// 需要展示的节日集合，可以转换成可配置内容
export const holidayList = [
    /**
     * holidayType: 1 公历现代节日 SolarFestival
     * holidayType: 2 农历传统节日 LunarFestival
     * holidayType: 3 节气 SolarTerm
     * holidayType: 4 外国节日 foreignHoliday
     * holidayType: 5 其他特殊日期 foreignHoliday
    */
    { holidayName: "元旦节", holidayType: 1, nameMap: '元旦'},
    { holidayName: "小寒", holidayType: 3 },
    { holidayName: "大寒", holidayType: 3 },
    { holidayName: "春节", holidayType: 2, nameMap: '除夕'},
    { holidayName: "立春", holidayType: 3 },
    { holidayName: "元宵节", holidayType: 2 },
    { holidayName: "情人节", holidayType: 4, nameMap: "Valentine's Day" },
    { holidayName: "雨水", holidayType: 3 },
    { holidayName: "惊蛰", holidayType: 3 },
    { holidayName: "妇女节", holidayType: 1, nameMap: '三八妇女节' },
    { holidayName: "植树节", holidayType: 1 },
    { holidayName: "消费者权益日", holidayType: 5, defaultDate: '03-15' },
    { holidayName: "春分", holidayType: 3 },
    { holidayName: "清明", holidayType: 2 },
    { holidayName: "谷雨", holidayType: 3 },
    { holidayName: "地球日", holidayType: 5, defaultDate: '04-22' },
    { holidayName: "劳动节", holidayType: 1, nameMap: '五一劳动节' },
    { holidayName: "青年节", holidayType: 1, nameMap: '五四青年节' },
    { holidayName: "立夏", holidayType: 3 },
    { holidayName: "母亲节", holidayType: 4, nameMap: "Mother's Day" },
    { holidayName: "小满", holidayType: 3 },
    { holidayName: "儿童节", holidayType: 1, nameMap: '六一儿童节' },
    { holidayName: "芒种", holidayType: 3 },
    { holidayName: "父亲节", holidayType: 4, nameMap: "Father's Day" },
    { holidayName: "夏至", holidayType: 3 },
    { holidayName: "端午节", holidayType: 2 },
    { holidayName: "建党节", holidayType: 1 },
    { holidayName: "小暑", holidayType: 3 },
    { holidayName: "大暑", holidayType: 3 },
    { holidayName: "立秋", holidayType: 3 },
    { holidayName: "七夕节", holidayType: 2 },
    { holidayName: "处暑", holidayType: 3 },
    { holidayName: "白露", holidayType: 3 },
    { holidayName: "秋分", holidayType: 3 },
    { holidayName: "中秋节", holidayType: 2 },
    { holidayName: "国庆节", holidayType: 1 },
    { holidayName: "寒露", holidayType: 3 },
    { holidayName: "重阳节", holidayType: 2 },
    { holidayName: "霜降", holidayType: 3 },
    { holidayName: "万圣节", holidayType: 4, nameMap: 'Halloween' },
    { holidayName: "立冬", holidayType: 3 },
    { holidayName: "小雪", holidayType: 3 },
    { holidayName: "感恩节", holidayType: 4, nameMap: 'Thanksgiving Day' },
    { holidayName: "大雪", holidayType: 3 },
    { holidayName: "冬至", holidayType: 3 },
    { holidayName: "圣诞节", holidayType: 4, nameMap: 'Christmas Day' },
    { holidayName: "腊八节", holidayType: 2, },
    { holidayName: "除夕", holidayType: 2, },
    { holidayName: '建军节', holidayType: 1, nameMap: '八一建军节' },
];
export const holidayInfo = [
    { date: '2023-1-1', holidayName: '元旦节' },
    { date: '2023-1-5', holidayName: '小寒' },
    { date: '2023-1-20', holidayName: '大寒' },
    { date: '2023-1-22', holidayName: '春节' },
    { date: '2023-2-4', holidayName: '立春' },
    { date: '2023-2-5', holidayName: '元宵节' },
    { date: '2023-2-14', holidayName: '情人节' },
    { date: '2023-2-19', holidayName: '雨水' },
    { date: '2023-3-6', holidayName: '惊蛰' },
    { date: '2023-3-8', holidayName: '妇女节' },
    { date: '2023-3-12', holidayName: '植树节' },
    { date: '2023-3-15', holidayName: '国际消费者权益日' },
    { date: '2023-3-21', holidayName: '春分' },
    { date: '2023-4-5', holidayName: '清明' },
    { date: '2023-4-20', holidayName: '谷雨' },
    { date: '2023-4-22', holidayName: '地球日' },
    { date: '2023-5-1', holidayName: '劳动节' },
    { date: '2023-5-4', holidayName: '青年节' },
    { date: '2023-5-6', holidayName: '立夏' },
    { date: '2023-5-14', holidayName: '母亲节' },
    { date: '2023-5-21', holidayName: '小满' },
    { date: '2023-6-1', holidayName: '儿童节' },
    { date: '2023-6-6', holidayName: '芒种' },
    { date: '2023-6-18', holidayName: '父亲节' },
    { date: '2023-6-21', holidayName: '夏至' },
    { date: '2023-6-22', holidayName: '端午节' },
    { date: '2023-7-1', holidayName: '建党节' },
    { date: '2023-7-7', holidayName: '小暑' },
    { date: '2023-7-23', holidayName: '大暑' },
    { date: '2023-8-8', holidayName: '立秋' },
    { date: '2023-8-22', holidayName: '七夕节' },
    { date: '2023-8-23', holidayName: '处暑' },
    { date: '2023-9-8', holidayName: '白露' },
    { date: '2023-9-23', holidayName: '秋分' },
    { date: '2023-9-29', holidayName: '中秋节' },
    { date: '2023-10-1', holidayName: '国庆节' },
    { date: '2023-10-8', holidayName: '寒露' },
    { date: '2023-10-23', holidayName: '重阳节' },
    { date: '2023-10-24', holidayName: '霜降' },
    { date: '2023-10-31', holidayName: '万圣节' },
    { date: '2023-11-8', holidayName: '立冬' },
    { date: '2023-11-22', holidayName: '小雪' },
    { date: '2023-11-23', holidayName: '感恩节' },
    { date: '2023-12-7', holidayName: '大雪' },
    { date: '2023-12-22', holidayName: '冬至' },
    { date: '2023-12-25', holidayName: '圣诞节' },
    { date: '2024-1-1', holidayName: '元旦节' },
    { date: '2024-1-6', holidayName: '小寒' },
    { date: '2024-1-18', holidayName: '腊八节' },
    { date: '2024-1-20', holidayName: '大寒' },
    { date: '2024-2-4', holidayName: '立春' },
    { date: '2024-2-9', holidayName: '除夕' },
    { date: '2024-2-10', holidayName: '春节' },
    { date: '2024-2-14', holidayName: '情人节' },
    { date: '2024-2-19', holidayName: '雨水' },
    { date: '2024-2-24', holidayName: '元宵节' },
    { date: '2024-3-5', holidayName: '惊蛰' },
    { date: '2024-3-8', holidayName: '妇女节' },
    { date: '2024-3-12', holidayName: '植树节' },
    { date: '2024-3-15', holidayName: '国际消费者权益日' },
    { date: '2024-3-20', holidayName: '春分' },
    { date: '2024-4-4', holidayName: '清明' },
    { date: '2024-4-19', holidayName: '谷雨' },
    { date: '2024-4-22', holidayName: '地球日' },
    { date: '2024-5-1', holidayName: '劳动节' },
    { date: '2024-5-4', holidayName: '青年节' },
    { date: '2024-5-5', holidayName: '立夏' },
    { date: '2024-5-12', holidayName: '母亲节' },
    { date: '2024-5-20', holidayName: '小满' },
    { date: '2024-6-1', holidayName: '儿童节' },
    { date: '2024-6-5', holidayName: '芒种' },
    { date: '2024-6-10', holidayName: '端午节' },
    { date: '2024-6-16', holidayName: '父亲节' },
    { date: '2024-6-21', holidayName: '夏至' },
    { date: '2024-7-1', holidayName: '建党节' },
    { date: '2024-7-6', holidayName: '小暑' },
    { date: '2024-7-22', holidayName: '大暑' },
    { date: '2024-8-1', holidayName: '建军节' },
    { date: '2024-8-7', holidayName: '立秋' },
    { date: '2024-8-22', holidayName: '处暑' },
    { date: '2024-9-7', holidayName: '白露' },
    { date: '2024-9-17', holidayName: '中秋节' },
    { date: '2024-9-22', holidayName: '秋分' },
    { date: '2024-10-1', holidayName: '国庆节' },
    { date: '2024-10-8', holidayName: '寒露' },
    { date: '2024-10-11', holidayName: '重阳节' },
    { date: '2024-10-23', holidayName: '霜降' },
    { date: '2024-10-31', holidayName: '万圣节' },
    { date: '2024-11-22', holidayName: '小雪' },
    { date: '2024-11-28', holidayName: '感恩节' },
    { date: '2024-12-25', holidayName: '圣诞节' },
    { date: '2024-11-7', holidayName: '立冬' },
    { date: '2024-12-6', holidayName: '大雪' },
    { date: '2024-12-21', holidayName: '冬至' },
    { date: '2025-1-7', holidayName: '腊八节' }
]

// export const getHolidayList = function () {
//     let res = [];
//     let count = 0;
//     for (const item of holidayInfo) {
//         if (count >= 11) {
//             break;
//         }
//         const date1 = new Date();
//         const date2 = new Date(item.date);
//         let diffTime = date2 - date1;
//         let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//         if (diffDays >= 0) {
//             res.push({
//                 ...item,
//                 diffDays
//             })
//             count++;
//         }
//     }
//     return res;
// }

// export const getHolidayList = async function () {
//     try{
//         const holidayInfoList = await fetchData(urls.home.getHolidayInfo);
//         const res = holidayInfoList.slice(0, 11).map(item => ({
//             holidayName: item.holidayName,
//             diffDays: item.diffDay
//         }))
//         console.log(res)
//         return res
//     }catch(e){
//         return []
//     }
// }

export const marchListType = [
    {
        label: '全部',
        value: '-1'
    },
    {
        label: '点赞多',
        value: '1'
    },
    {
        label: '下载多',
        value: '2'
    },
    {
        label: '浏览多',
        value: '3'
    },
    {
        label: '收藏多',
        value: '4'
    },
    {
        label: '分享多',
        value: '5'
    }
]

export const updateTypeList = [
    {
        label: '最近更新',
        value: 'updateTime'
    },
    {
        label: '下载最多',
        value: 'downloadNum'
    },
    {
        label: '浏览最多',
        value: 'browseNum'
    }
    // {
    //     label: '一天内更新',
    //     value: '2'
    // },
    // {
    //     label: '一周内更新',
    //     value: '3'
    // },
    // {
    //     label: '一月内更新',
    //     value: '4'
    // },
    // {
    //     label: '最近创建',
    //     value: '5'
    // }
]
export const sourceListType = [
    {
        label: '全部',
        value: '-1'
    },
    {
        label: '美团',
        value: '0'
    },
    {
        label: '站酷海洛',
        value: '1'
    },
    {
        label: '视觉中国',
        value: '2'
    },
    {
        label: '图虫',
        value: '3'
    },
]
export const copyrightTypeList = [
    {
        label: '全部',
        value: '-1'
    },
    {
        label: '原创',
        value: '1'
    },
    {
        label: '非原创',
        value: '0'
    }
]

export const styleListType = [
    {
        label: '全部',
        value: '-1'
    },
    {
        label: '简约风',
        value: '1'
    },
    {
        label: '三维风',
        value: '2'
    },
    {
        label: '扁平风',
        value: '3'
    },
    {
        label: '科技风',
        value: '4'
    },
    {
        label: '手绘风',
        value: '5'
    },
    {
        label: '中国风',
        value: '6'
    },
]
export const colorListType = [
    {
        label: '全部',
        value: '-1',
    },
    {
        label: '黄色',
        value: '#FFD100'
    },
    {
        label: '橙色',
        value: '#FA7414'
    },
    {
        label: '红色',
        value: '#FF4A47'
    },
    {
        label: '粉色',
        value: '#F04888'
    },
    {
        label: '紫色',
        value: '#9152F5'
    },
    {
        label: '蓝色',
        value: '#3888FF'
    },
    {
        label: '青色',
        value: '#12B5B8'
    },
    {
        label: '绿色',
        value: '#00BA73'
    },
    {
        label: '棕色',
        value: '#B38A62'
    },
    {
        label: '白色',
        value: '#FFFFFF'
    },
    {
        label: '灰色',
        value: '#E6E6E6'
    },
    {
        label: '黑色',
        value: '#000000'
    },
]

export const sizeListType = [
    {
        label: '全部',
        value: '-1',
    }
]

export const formateListType = [
    {
        label: '全部',
        value: '-1'
    }
]
export const picRateListType = [
    {
        label: '全部',
        value: '-1'
    },
    {
        label: "4:3",
        value: '1'
    },
    {
        label: "16:9",
        value: '2'
    },
    {
        label: "1:1",
        value: '3'
    },
    {
        label: "3:4",
        value: '4'
    },
    {
        label: "9:16",
        value: '5'
    }
]

export const humanResourceTypeList = [
    {
        value: '1',
        label: '官方素材'
    },
    {
        value: '2',
        label: '模板素材'
    },
    {
        value: '3',
        label: '衍生素材'
    }
]

export const humanResourceDirectoryTypeList = humanResourceDirectoryList.map(item => ({
    value: item.value,
    label: item.label
}))


export const GlobalSearchList = [
    {
        label: '全部',
        value: Resource_Type_Identifier.ALL,
        canColorSearch: true,
        canPicSearch: true,
        resourceListType: [
            {
                label: '全部',
                value: Resource_Type_Identifier.ALL
            },
            {
                label: '版权图库',
                value: Resource_Type_Identifier.PX_IMAGE
            },
            {
                label: '视频',
                value: Resource_Type_Identifier.PX_VIDEO
            },
            {
                label: '音频',
                value: Resource_Type_Identifier.PX_AUDIO
            },
            {
                label: '品牌设计',
                value: Resource_Type_Identifier.BRAND_MATERIAL
            },
            {
                label: '营销设计',
                value: Resource_Type_Identifier.MARKET_MATERIAL
            },
            {
                label: '产品设计',
                value: Resource_Type_Identifier.PRODUCT_MATERIAL
            },
            {
                label: '图标库',
                value: Resource_Type_Identifier.ICON
            },
            {
                label: '人力资源设计',
                value: Resource_Type_Identifier.CORPORATECULTURE_MATERIAL,
                canColorSearch: true,
                canPicSearch: true
            },
            {
                label: '设计指南',
                value: Resource_Type_Identifier.DESIGN_GUIDE
            },
            {
                label: '字体',
                value: Resource_Type_Identifier.PX_FONT
            }
        ],
        marchListType: marchListType,
        updateTypeList: updateTypeList,
        sourceListType: sourceListType,
        copyrightTypeList: copyrightTypeList
    },
    {
        label: '图片',
        value: Resource_Type_Identifier.PX_IMAGE,
        canColorSearch: true,
        canPicSearch: true,
        hasIsBuyFilter: true,
        marchListType: marchListType,
        sourceListType: sourceListType,
        copyrightTypeList: copyrightTypeList,
        styleListType: styleListType,
        colorListType: colorListType,
        sizeListType: sizeListType,
        formateListType: formateListType,
        picRateListType: picRateListType
    },
    {
        label: '视频',
        value: Resource_Type_Identifier.PX_VIDEO,
        canColorSearch: false,
        canPicSearch: false,
        hasIsBuyFilter: true,
        marchListType: marchListType,
        sourceListType: sourceListType,
        copyrightTypeList: copyrightTypeList,
        sizeListType: sizeListType,
        formateListType: formateListType,
        picRateListType: picRateListType,
        videoDisplayListType: displayFps,
        videoTimeListType: videoTime,
    },
    {
        label: '音频',
        value: Resource_Type_Identifier.PX_AUDIO,
        canColorSearch: false,
        canPicSearch: false,
        hasIsBuyFilter: true,
        marchListType: marchListType,
        sourceListType: sourceListType,
        copyrightTypeList: copyrightTypeList,
        audioTimeListType: videoTime,
        audioBpmListType: bpmList
    },
    // {
    //     label: '品牌规范',
    //     value: Resource_Type_Identifier.BRAND_MATERIAL,
    //     canColorSearch: true,
    //     canPicSearch: true,
    //     marchListType: marchListType,
    //     updateTypeList: updateTypeList,
    //     sourceListType: [{ label: "美团", value: '0' }],
    //     copyrightTypeList: copyrightTypeList,
    //     styleListType: styleListType,
    //     colorListType: colorListType,
    //     sizeListType: sizeListType,
    //     formateListType: formateListType,
    //     picRateListType: picRateListType,
    // },
    {
        label: '品牌营销素材',
        value: Resource_Type_Identifier.MARKET_MATERIAL,
        canColorSearch: true,
        canPicSearch: true,
        marchListType: marchListType,
        updateTypeList: updateTypeList,
        sourceListType: [{ label: "美团", value: '0' }],
        copyrightTypeList: copyrightTypeList,
        styleListType: styleListType,
        colorListType: colorListType,
        sizeListType: sizeListType,
        formateListType: formateListType,
        picRateListType: picRateListType,
    },
    {
        label: '营销规范',
        value: Resource_Type_Identifier.MARKET_GUIDELINE,
        canColorSearch: true,
        canPicSearch: true,
        marchListType: marchListType,
        updateTypeList: updateTypeList,
        sourceListType: [{ label: "美团", value: '0' }],
        copyrightTypeList: copyrightTypeList,
        styleListType: styleListType,
        colorListType: colorListType,
        sizeListType: sizeListType,
        formateListType: formateListType,
        picRateListType: picRateListType,
    },
    {
        label: '产品设计',
        value: Resource_Type_Identifier.PRODUCT_MATERIAL,
        canColorSearch: true,
        canPicSearch: true,
        marchListType: marchListType,
        updateTypeList: updateTypeList,
        sourceListType: [{ label: "美团", value: '0' }],
        copyrightTypeList: copyrightTypeList,
        colorListType: colorListType,
        sizeListType: sizeListType,
        formateListType: formateListType,
    },
    // {
    //     label: '图标库',
    //     value: Resource_Type_Identifier.ICON,
    //     canColorSearch: false,
    //     canPicSearch: true,
    //     marchListType: marchListType,
    //     updateTypeList: updateTypeList,
    //     sourceListType: [{ label: "美团", value: '0' }],
    //     copyrightTypeList: copyrightTypeList,
    // },
    {
        label: 'AI案例',
        value: Resource_Type_Identifier.AIGC,
        canColorSearch: true,
        canPicSearch: true,
        marchListType: marchListType,
        updateTypeList: updateTypeList,
        sourceListType: [{ label: "美团", value: '0' }],
        copyrightTypeList: copyrightTypeList,
        styleListType: styleListType,
        colorListType: colorListType,
        sizeListType: sizeListType,
        formateListType: formateListType,
        picRateListType: picRateListType,
    },
    {
        label: '企业文化素材',
        value: Resource_Type_Identifier.CORPORATECULTURE_MATERIAL,
        canColorSearch: true,
        canPicSearch: true,
        marchListType: marchListType,
        updateTypeList: updateTypeList,
        sourceListType: [{ label: "美团", value: '0' }],
        copyrightTypeList: copyrightTypeList,
        colorListType: colorListType,
        sizeListType: sizeListType,
        formateListType: formateListType,
        picRateListType: picRateListType,
    },
    // {
    //     label: '设计指南',
    //     value: Resource_Type_Identifier.DESIGN_GUIDE,
    //     canColorSearch: false,
    //     canPicSearch: false,
    //     marchListType: marchListType,
    //     updateTypeList: updateTypeList,
    //     sourceListType: [{ label: "美团", value: '0' }],
    // },
    // {
    //     label: '字体',
    //     value: Resource_Type_Identifier.PX_FONT,
    //     canColorSearch: false,
    //     canPicSearch: false,
    //     marchListType: marchListType,
    //     copyrightTypeList: copyrightTypeList,
    //     styleListType: styleListType,
    // }
]

export const GlobalSearchType = {
    NO_SEARCH: 0,
    SEARCH_WORD: 1,
    SEARCH_COLOR: 2,
    SEARCH_PIC: 3
}

export const GlobalColorSearchTypeList = [
    {
        name: '黄色',
        color: '#FFD100'
    },
    {
        name: '橙色',
        color: '#FA7414'
    },
    {
        name: '红色',
        color: '#FF4A47'
    },
    {
        name: '粉色',
        color: '#F04888'
    },
    {
        name: '紫色',
        color: '#9152F5'
    },
    {
        name: '蓝色',
        color: '#3888FF'
    },
    {
        name: '青色',
        color: '#12B5B8'
    },
    {
        name: '绿色',
        color: '#00BA73'
    },
    {
        name: '棕色',
        color: '#B38A62'
    },
    {
        name: '白色',
        color: '#FFFFFF'
    },
    {
        name: '灰色',
        color: '#E6E6E6'
    },
    {
        name: '黑色',
        color: '#000000'
    },
]
